import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


// Смысловые блоки кабинета лаборатории. Блок определяется по префиксу URL,
// поэтому переход по ссылке в другой блок сам переключает активный блок.
export const BLOCKS = {
  documents: {
    id: 'documents',
    title: 'Документы',
    description: 'Каталог, заказ и договор, счета и бухгалтерские документы',
    icon: 'bi-file-earmark-text',
    path: '/documents',
    ticketQueue: 'documents',
    ticketsTitle: 'Обращения по вопросам договора',
    menu: [
      { title: 'О разделе', to: '/documents' },
      { title: 'Каталог', to: '/documents/catalog', currentYearOnly: true },
      { title: 'Заказ и договор', to: '/documents/order' },
      { title: 'Обращения', to: '/documents/tickets' },
    ],
  },
  results: {
    id: 'results',
    title: 'Результаты исследований',
    description: 'Задания, материалы заданий и отчеты о результатах исследований',
    icon: 'bi-clipboard2-data',
    path: '/results',
    ticketQueue: 'forms',
    ticketsTitle: 'Обращения по результатам исследований',
    menu: [
      { title: 'О разделе', to: '/results' },
      { title: 'Задания', to: '/results/tasks' },
      { title: 'Календарь', to: '/results/calendar' },
      { title: 'Результаты', to: '/results/reports' },
      { title: 'Обращения', to: '/results/tickets' },
    ],
  },
  certificates: {
    id: 'certificates',
    title: 'Свидетельства',
    description: 'Свидетельства лаборатории, полученные в ходе исполнения договора',
    icon: 'bi-award',
    path: '/certificates',
    menu: [
      { title: 'О разделе', to: '/certificates' },
    ],
  },
};

export const OLD_LK_URL = 'https://portal2.fsvok.ru/fsvok_work/ru_RU/';

// Блоки, в которых лаборатория работает с обращениями
export const TICKET_BLOCKS = [BLOCKS.documents, BLOCKS.results];

const ACTIVE_BLOCK_STORAGE_KEY = 'activeBlock';


export function blockFromPath(pathname) {
  return Object.values(BLOCKS).find(
    block => pathname === block.path || pathname.startsWith(block.path + '/')
  ) ?? null;
}


export function blockForQueue(queue) {
  return TICKET_BLOCKS.find(block => block.ticketQueue === queue) ?? null;
}


export function otherTicketBlock(block) {
  return TICKET_BLOCKS.find(ticketBlock => ticketBlock.id !== block.id);
}


// Активный блок: из URL, а на общих страницах (профиль, уведомления) — последний открытый.
// На главной странице блок не выбран.
export function useActiveBlock() {
  const { pathname } = useLocation();
  const urlBlock = blockFromPath(pathname);

  useEffect(() => {
    if (urlBlock) {
      localStorage.setItem(ACTIVE_BLOCK_STORAGE_KEY, urlBlock.id);
    }
  }, [urlBlock]);

  if (urlBlock) {
    return urlBlock;
  }
  if (pathname === '/') {
    return null;
  }
  const storedBlockId = localStorage.getItem(ACTIVE_BLOCK_STORAGE_KEY);
  return Object.values(BLOCKS).find(block => block.id === storedBlockId) ?? null;
}
